"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgTransFatFreeFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10ZM6.293 7.707 8.034 9.45c-1.069 1.477-1.334 3.459-.678 5.207C8.105 16.654 9.928 18 12 18a4.823 4.823 0 0 0 3.283-1.303l1.01 1.01.094.083a1 1 0 0 0 1.32-1.497l-1.233-1.233c.062-.131.119-.266.17-.404.725-1.931.325-4.147-1.041-5.655l-2.12-2.343a2 2 0 0 0-2.966 0L9.356 7.942l-1.649-1.65-.094-.082a1 1 0 0 0-1.32 1.497Zm2.935 6.247a3.614 3.614 0 0 1 .25-3.062l4.389 4.389c-.52.456-1.174.719-1.867.719-1.213 0-2.308-.807-2.772-2.046Zm4.893-3.61c.753.832 1.043 2.032.788 3.151l-4.137-4.137L12 8l2.12 2.344Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgTransFatFreeFilled);
//# sourceMappingURL=SvgTransFatFreeFilled.js.map